import { apiInstance } from "src/services";

export async function handleDownloadCsvFile(report_id : string , id : string | undefined) {
    try {
     
        const response = await apiInstance.post('/reporttool/organisationlevel/sites/issues/csv/download', {
            report_id
        }, {
            responseType: 'blob'
        });
       
        if ( response?.status !== 200 ) return { error: new Error('Download failed') }

        const contentDisposition = response?.headers['content-disposition'];
        const downloadDate = new Date();
        const formattedDate = downloadDate.toISOString().slice(0, 10);
        let filename = `${id ?? 'report'}-${formattedDate}.csv`;

        // if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
        //     const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
        //     if (matches != null && matches[1]) {
        //         filename = matches[1].replace(/['"]/g, '');
        //     }
        // }
        // filename = `${formattedDate}_${filename}`;
        const blob = new Blob([response.data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);

        // console.log('File downloaded successfully');

        return { error: null };
        } catch(error:any) {

            console.log( error );
            
            return {
                error: new Error('Download failed')
            }
        }
}

export async function handleDownloadExcelFile(report_id : string , id : string | undefined ) {
    try {
     
        const response = await apiInstance.post('/reporttool/organisationlevel/sites/issues/excel/download', {
            report_id
        }, {
            responseType: 'blob'
        });
        if ( response?.status !== 200 ) return { error: new Error('Download failed') }
        // const contentDisposition = response.headers['content-disposition'];
        const downloadDate = new Date();
        const formattedDate = downloadDate.toISOString().slice(0, 10);
        let filename = `${id ?? 'report'}-${formattedDate}.xlsx`;

        // if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
        //     const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
        //     if (matches != null && matches[1]) {
        //     filename = matches[1].replace(/['"]/g, '');
        //     }
        // }
        // filename = `${formattedDate}_${filename}`;
        const blob = new Blob([response.data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);

        // console.log('File downloaded successfully');

        return { error: null };
        } catch {
            return {
                error: new Error('Download failed')
            }
        }
}